import { FC } from 'react';
import { ApiItem } from '../../../lib/interfaces/ApiControl';
import ContentRenderer from '../Content/ContentRenderer';
import CodeRow from '../../Simple/CodeRow/CodeRow';
import ApiControlEndpointTable from './ApiControlEndpointTable';
import ApiControlContentItem from './ApiControlContentItem';
import ApiControlExamples from './ApiControlExamples';

type ApiControlEndpointProps = {
	apiItem: ApiItem;
};

const ApiControlEndpoint: FC<ApiControlEndpointProps> = ({ apiItem }) => {
	console.log('HHH: ', apiItem);

	return (
		<>
			{apiItem.description && (
				<ApiControlContentItem title="Description">
					<ContentRenderer html={apiItem.description} />
				</ApiControlContentItem>
			)}

			{apiItem.endpoint && (
				<ApiControlContentItem title="Endpoint">
					<CodeRow row={apiItem.endpoint} withTheme />
				</ApiControlContentItem>
			)}

			{apiItem.urlParams && !!apiItem.urlParams.length && (
				<ApiControlContentItem title="Url params">
					<ApiControlEndpointTable data={apiItem.urlParams} />
				</ApiControlContentItem>
			)}

			{apiItem.headers && !!apiItem.headers.length && (
				<ApiControlContentItem title="Headers">
					<ApiControlEndpointTable data={apiItem.headers} />
				</ApiControlContentItem>
			)}

			{apiItem.bodyParams && !!apiItem.bodyParams.length && (
				<ApiControlContentItem title="Body params">
					<ApiControlEndpointTable data={apiItem.bodyParams} />
				</ApiControlContentItem>
			)}

			{apiItem.examples && !!apiItem.examples.length && (
				<ApiControlContentItem title="Examples">
					<ApiControlExamples examples={apiItem.examples} />
				</ApiControlContentItem>
			)}
		</>
	);
};

export default ApiControlEndpoint;
